import React, { forwardRef } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
var GroupListItemSkeleton = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem, {
    disablePadding: true,
    ref: ref
  }, /*#__PURE__*/React.createElement(ListItemButton, null, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "circular",
    height: 40,
    width: 40
  })), /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Skeleton, {
      width: 150
    }),
    secondary: /*#__PURE__*/React.createElement(Skeleton, {
      width: 150
    })
  }))), /*#__PURE__*/React.createElement(Divider, {
    component: "li"
  }));
});
export default GroupListItemSkeleton;